import { getPath } from '@/router/common'

const baseUrl = {
  title: '客户预约',
  path: 'sendPack_SB'
}
export default [
  {
    path: getPath('CustomerYuyue_SB', baseUrl),
    name: 'SendPack_SB_CustomerYuyue_SB',
    component: () => import(/* webpackChunkName: "SendPack_SB_CustomerYuyue_SB" */ '@/views/sendPack_SB/customerYuyue_SB/index.vue'),
    meta: {
      title: '客户预约'
    }
  },
  {
    path: getPath('NewCustomerYuyue_SB', baseUrl),
    name: 'SendPack_SB_NewCustomerYuyue_SB',
    component: () => import(/* webpackChunkName: "SendPack_SB_NewCustomerYuyue_SB" */ '@/views/sendPack_SB/newCustomerYuyue_SB/index.vue'),
    meta: {
      title: '开启预约'
    }
  },
  {
    path: getPath('SendOrders_SB', baseUrl),
    name: 'SendOrders_SB',
    component: () =>
      import(
        /* webpackChunkName: "SendOrders_SB" */ '@/views/sendPack_SB/sendOrders_SB/index.vue'
      ),
    meta: {
      title: '三包派单'
    }
  },
  {
    path: getPath('Chauffeurpick_SB', baseUrl),
    name: 'Chauffeurpick_SB',
    component: () =>
      import(
        /* webpackChunkName: "Chauffeurpick_SB" */ '@/views/sendPack_SB/chauffeurpick_SB/index.vue'
      ),
    meta: {
      title: '师傅提货'
    }
  },
  {
    path: getPath('SignComplete_SB', baseUrl),
    name: 'SignComplete_SB',
    component: () =>
      import(
        /* webpackChunkName: "SignComplete_SB" */ '@/views/sendPack_SB/signComplete_SB/index.vue'
      ),
    meta: {
      title: '签收完成'
    }
  },
  {
    path: getPath('catch_SB', baseUrl),
    name: 'catch_SB',
    component: () =>
      import(
        /* webpackChunkName: "catch_SB" */ '@/views/sendPack_SB/catch_SB/index.vue'
      ),
    meta: {
      title: '异常登记'
    }
  },
  {
    path: getPath('Summation_SB', baseUrl),
    name: 'Summation_SB',
    component: () =>
      import(
        /* webpackChunkName: "Summation_SB" */ '@/views/sendPack_SB/summation_SB/index.vue'
      ),
    meta: {
      title: '三包统计'
    }
  },
  {
    path: getPath('SendOrders_Modify_SB', baseUrl),
    name: 'SendOrders_Modify_SB',
    component: () =>
      import(
        /* webpackChunkName: "SendOrders_Modify_SB" */ '@/views/sendPack_SB/sendOrders_Modify_SB/index.vue'
      ),
    meta: {
      title: '三包派单明细'
    }
  },
  {
    path: getPath('ImportSbRecord', baseUrl),
    name: 'ImportSbRecord',
    component: () =>
      import(
        /* webpackChunkName: "ImportSbRecord" */ '@/views/sendPack_SB/importSbRecord/index.vue'
      ),
    meta: {
      title: '三包派单导入'
    }
  },
  {
    path: getPath('NewSendOrders_SB', baseUrl),
    name: 'NewSendOrders_SB',
    component: () =>
      import(
        /* webpackChunkName: "NewSendOrders_SB" */ '@/views/sendPack_SB/newSendOrders_SB/index.vue'
      ),
    meta: {
      title: '安排派车'
    }
  },
  {
    path: getPath('SbOrdersImport', baseUrl),
    name: 'SbOrdersImport',
    component: () =>
      import(
        /* webpackChunkName: "SbOrdersImport" */ '@/views/sendPack_SB/sbOrdersImport/index.vue'
      ),
    meta: {
      title: '导入运单'
    }
  },
  {
    path: getPath('ImportSbRecordDetail', baseUrl),
    name: 'ImportSbRecordDetail',
    component: () =>
      import(
        /* webpackChunkName: "ImportSbRecordDetail" */ '@/views/sendPack_SB/importSbRecordDetail/index.vue'
      ),
    meta: {
      title: '三包派单记录明细'
    }
  },
  {
    path: getPath('Chauffeurpick_Info_SB', baseUrl),
    name: 'Chauffeurpick_Info_SB',
    component: () =>
      import(
        /* webpackChunkName: "Chauffeurpick_Info_SB" */ '@/views/sendPack_SB/chauffeurpick_SB/chauffeurpick_Info_SB/index.vue'
      ),
    meta: {
      title: '提货明细'
    }
  },
  {
    path: getPath('NoneSignComplete_SB', baseUrl),
    name: 'NoneSignComplete_SB',
    component: () =>
      import(
        /* webpackChunkName: "NoneSignComplete_SB" */ '@/views/sendPack_SB/signComplete_SB/noneSignComplete_SB/index.vue'
      ),
    meta: {
      title: '三包单票签收'
    }
  },
  {
    path: getPath('AddSignComplete_SB', baseUrl),
    name: 'AddSignComplete_SB',
    component: () =>
      import(
        /* webpackChunkName: "AddSignComplete_SB" */ '@/views/sendPack_SB/signComplete_SB/addSignComplete_SB/index.vue'
      ),
    meta: {
      title: '开始签收'
    }
  },
  {
    path: getPath('catch_Edit', baseUrl),
    name: 'catch_Edit',
    component: () =>
      import(
        /* webpackChunkName: "catch_Edit" */ '@/views/sendPack_SB/catch_SB/catch_Edit/index.vue'
      ),
    meta: {
      title: '货差货损'
    }
  },
  {
    path: getPath('catch_Check_SB', baseUrl),
    name: 'catch_Check_SB',
    component: () =>
      import(
        /* webpackChunkName: "catch_Check_SB" */ '@/views/sendPack_SB/catch_SB/catch_Check_SB/index.vue'
      ),
    meta: {
      title: '货差货损'
    }
  },
  {
    path: getPath('ChauffeurInfo_SB', baseUrl),
    name: 'ChauffeurInfo_SB',
    component: () =>
      import(
        /* webpackChunkName: "ChauffeurInfo_SB" */ '@/views/sendPack_SB/chauffeurInfo_SB/index.vue'
      ),
    meta: {
      title: '师傅档案'
    }
  },
  {
    path: getPath('SubChauffeurInfo_SB', baseUrl),
    name: 'SubChauffeurInfo_SB',
    component: () =>
      import(
        /* webpackChunkName: "SubChauffeurInfo_SB" */ '@/views/sendPack_SB/subChauffeurInfo_SB/index.vue'
      ),
    meta: {
      title: '师傅子账号'
    }
  },
  {
    path: getPath('ChauffeurInfoAddOrEdit_SB', baseUrl),
    name: 'ChauffeurInfoAddOrEdit_SB',
    component: () =>
      import(
        /* webpackChunkName: "ChauffeurInfoAddOrEdit_SB" */ '@/views/sendPack_SB/chauffeurInfo_SB/chauffeurInfoAddOrEdit_SB/index.vue'
      ),
    meta: {
      title: '新增/修改'
    }
  },
  {
    path: getPath('sfPrice', baseUrl),
    name: 'sfPrice',
    component: () =>
      import(
        /* webpackChunkName: "sfPrice" */ '@/views/sendPack_SB/chauffeurInfo_SB/sfPrice/index.vue'
      ),
    meta: {
      title: '师傅价格体系'
    }
  },
  {
    path: getPath('PL_NoneSignComplete_SB', baseUrl),
    name: 'PL_NoneSignComplete_SB',
    component: () =>
      import(
        /* webpackChunkName: "pL_NoneSignComplete_SB" */ '@/views/sendPack_SB/signComplete_SB/pL_NoneSignComplete_SB/index.vue'
      ),
    meta: {
      title: '三包批量签收'
    }
  },
  {
    path: getPath('sfPriceAdd', baseUrl),
    name: 'sfPriceAdd',
    component: () => import(/* webpackChunkName: "sfPriceAdd" */ '@/views/sendPack_SB/sfPriceAdd/index.vue'),
    meta: {
      title: '打开导入运单弹窗、新增/导入师傅价格'
    }
  },
  {
    path: getPath('SendOrders_SB_editAcc', baseUrl),
    name: 'SendOrders_SB_editAcc',
    component: () => import(/* webpackChunkName: "SendOrders_SB_editAcc" */ '@/views/sendPack_SB/sendOrders_SB_editAcc/index.vue'),
    meta: {
      title: '调整师傅费用'
    }
  },
  {
    path: getPath('SendOrders_SB_Batch_EditAcc', baseUrl),
    name: 'SendOrders_SB_Batch_EditAcc',
    component: () => import(/* webpackChunkName: "SendOrders_SB_editAcc" */ '@/views/sendPack_SB/sendOrders_SB_Batch_EditAcc/index.vue'),
    meta: {
      title: '批量调整师傅费用'
    }
  }
]
